import React, { useState } from 'react';
import './Portfolio.css';
import portfolioImage1 from '../images/portfolio1.png';
import portfolioImage2 from '../images/portfolio2.png';
import AnnulaireImage from '../images/assention.jpg';
import AnnulaireImage1 from '../images/assention1.jpg';
import donImage from '../images/don.jpg';
import donImage1 from '../images/don1.jpg';
import mentorImage from '../images/mentor1.jpg';
import mentorImage1 from '../images/mentor2.jpg';
import project1_1 from '../images/project1_1.png';
import project1_2 from '../images/project1_2.png';
import project1_3 from '../images/project1_3.png';
import project1_4 from '../images/project1_4.png';
import project2_1 from '../images/project2_1.png';
import project2_2 from '../images/project2_2.png';
import project2_3 from '../images/project2_3.png';






function Portfolio() {
  const [selectedProject, setSelectedProject] = useState(null);

  const projects = [
    {
      title: "Web App Gestion des Officiels d'Athlétisme",
      description: "Application web de gestion des officiels d’athlétisme avec comptes utilisateurs (ajout/retrait). Intègre un calendrier des compétitions et un planning personnel des disponibilités. Gestion des formations, événements et qualifications des officiels. Utilisation de PostgreSQL pour le stockage des données.",
      link: "#",
      images: [
        project1_1,
        project1_2,
        project1_3,
        project1_4
      ]
    },
    {
      title: "Application pour l’analyse de sentiments sur Twitter",
      description: "Application d’analyse de sentiments sur Twitter classant les tweets en positif, négatif ou neutre. Utilisation d’algorithmes d’apprentissage supervisé tels que les dictionnaires, KNN et Bayes pour la classification.",
      link: "#",
      images: [
        project2_1,
        project2_2,
        project2_3
        
      ]
    },
    {
      title: "Mon Portfolio",
      description: "Mon portfolio est une application web que j’ai développée pour présenter mes compétences et réalisations en cloud computing et cybersécurité. Il regroupe mes projets marquants, avec des descriptions détaillées et des images illustratives. Construit avec React, il offre une navigation fluide et une mise en page moderne. Une section contact permet aux visiteurs de me joindre facilement.",
      link: "#",
      images: [
        portfolioImage1,
        portfolioImage2,
        
      ]
    },
    {
      title: "Un Site une Ascension ",
      description: "Annuaire en ligne des entreprises : N’Djamena est une ville qui regorge de petites et moyennes entreprises, mais il peut être difficile de les trouver. Un annuaire en ligne permettrait de rassembler toutes les entreprises de la ville en un seul endroit, ce qui faciliterait la recherche d’emplois et la recherche de partenaires commerciaux.",
      link: "#",
      images: [
        AnnulaireImage,
        AnnulaireImage1
      ]
    },
    {
      title: "Nos Dons",
      description: "Plateforme de dons en ligne : une plateforme de dons en ligne pourrait être mise en place pour soutenir des causes locales telles que la lutte contre la pauvreté, l’éducation, la santé, la protection de l’environnement et autres.",
      link: "#",
      images: [
        donImage,
        donImage1
            ]
    },
    {
      title: "On Purpose ",
      description: "Un site web pour du mentoring est une excellente ressource pour les personnes qui cherchent à améliorer leurs compétences ou à développer leur carrière. Un système de jumelage en ligne permettrait aux mentors et aux mentorés de se connecter facilement.",
      link: "#",
      images: [
        mentorImage,
        mentorImage1
      ]
    }
  ];

  const openModal = (project) => {
    setSelectedProject(project);
  };

  const closeModal = () => {
    setSelectedProject(null);
  };

  return (
    <section id="portfolio" className="portfolio-section">
      <h1 className="portfolio-title">MON PORTFOLIO</h1>
      <div className="projects-container">
        {projects.map((project, index) => (
          <div className="project-card" key={index}>
            <img
              src={project.images[0]}
              alt={project.title}
              className="project-img"
              onClick={() => openModal(project)}
            />
            <div className="card-body">
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <button onClick={() => openModal(project)} className="btn btn-primary">
                Voir le projet
              </button>
            </div>
          </div>
        ))}
      </div>

      {selectedProject && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>{selectedProject.title}</h2>
            <p>{selectedProject.description}</p>
            <div className="modal-images">
              {selectedProject.images.map((image, index) => (
                <img key={index} src={image} alt={`img ${index + 1}`} />
              ))}
            </div>
            <button className="btn btn-close" onClick={closeModal}>
              Fermer
            </button>
          </div>
        </div>
      )}
    </section>
  );
}

export default Portfolio;
